import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Terms of Use - asdflo</title>
        <meta name="description" content="Read the terms and conditions for using asdflo's platform and services." />
      </Helmet>
      
      <Header />
      
      <main className="flex-grow bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h1 className="text-3xl font-bold text-gray-900">Terms of Use</h1>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">Last updated: July 28, 2024</p>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
              <div className="prose max-w-none px-6 py-4 sm:px-6">
                <p className="text-gray-700 mb-4">
                  By accessing <a href="https://asdflo.com" className="text-blue-600 hover:underline">asdflo.com</a>, you agree to use our platform to connect with certified therapists, centers, and professionals.
                </p>
                <p className="text-gray-700 mb-4">
                  Services are booked by users at their discretion. Asdflo is a facilitator and not liable for advice given by third-party professionals.
                </p>
                <p className="text-gray-700 mb-4">
                  Therapists must be verified before listing on the platform.
                </p>
                <p className="text-gray-700">
                  For service issues or feedback, email us at: <a href="mailto:info@asdflo.com" className="text-blue-600 hover:underline">info@asdflo.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsOfUse;
